import { validateTenantConfig } from './validate-tenant-config/validate-tenant-config';
import { getCreateTenantConfigInfo } from '../configs/tenant-configs';
import { createTenantConfig } from './create-tenant-config';
import { isValidTenantId } from './is-valid-tenant-id';
import { captureErrorWithTenant } from './sentry-helpers';

export const getTenantConfig = (tenantId: string) => {
  if (!isValidTenantId(tenantId)) return undefined;

  try {
    const tenantConfigInfo = getCreateTenantConfigInfo(tenantId);
    const tenantConfig = createTenantConfig({ tenantId, ...tenantConfigInfo });
    return validateTenantConfig(tenantConfig);
  } catch (error) {
    // Construction throws on a misconfiguration it can't work around -- a base environment
    // that resolves to nothing, two environments sharing an environmentKey. Callers map
    // every tenant id they're given, so one escaping throw empties the whole switcher.
    // Undefined drops just the broken tenant, the path callers already have for an
    // unrecognised id.
    captureErrorWithTenant(
      error instanceof Error ? error : new Error(String(error)),
      tenantId,
      { errorName: 'TenantConfigConstructionFailure' },
    );
    return undefined;
  }
};
